/*
 *
 * ShelvesRibbon actions
 *
 */

import { action } from 'typesafe-actions';
import ActionTypes from '../constants/selection';

export const addToShelvesSelectionAction = (level: number) =>
  action(ActionTypes.ADD_TO_SHELVES_SELECTION, { level });

export const shelvesSelectionAction = (value: number[]) =>
  action(ActionTypes.SHELVES_SELECTION, { value });

export const shelvesSelectionSuccessAction = (value: number[]) =>
  action(ActionTypes.SHELVES_SELECTION_SUCCESS, { value });

export const shelfSelectionClearAction = () =>
  action(ActionTypes.SHELF_SELECTION_CLEAR);

export const selectDrawerShelvesAction = () =>
  action(ActionTypes.DRAWERS_SHELVES_SELECTION);

export const selectDoorsShelvesAction = () =>
  action(ActionTypes.DOORS_SHELVES_SELECTION);

export const selectBigShelvesShelvesAction = () =>
  action(ActionTypes.BIG_SHELVES_SHELVES_SELECTION);
